// 获取显示倒计时的元素
const timerElement = document.getElementById('countdown-timer');
const hoursElement = document.getElementById('hours');
const minutesElement = document.getElementById('minutes');
const secondsElement = document.getElementById('seconds');

// 倒计时函数
function countdownTimer(duration, callback) {
  const endTime = new Date().getTime() + duration * 60 * 60 * 1000;

  // 每隔一秒更新一次倒计时
  const interval = setInterval(() => {
    const timeDifference = endTime - new Date().getTime();

    // 如果时间差小于等于 0，则倒计时结束
    if (timeDifference <= 0) {
      clearInterval(interval);
      timerElement.textContent = 'Countdown Ended';
      if (typeof callback === 'function') {
        callback(); // 执行回调函数
      }
      return;
    }

    // 计算剩余的小时、分钟和秒数
    const hours = Math.floor(timeDifference / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    // 将剩余时间显示在页面上
    hoursElement.textContent = formatTime(hours);
    minutesElement.textContent = formatTime(minutes);
    secondsElement.textContent = formatTime(seconds);
  }, 1000);
}

// 格式化时间，保证显示为两位数
function formatTime(time) {
  return time < 10 ? `0${time}` : time;
}
